import React, { useEffect, useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import bannerImage from "../../Images/academic/teaching-padadogy-banner.webp";
import technologyImage from "../../Images/academic/technology-enhanced-learning.webp";
import { Link } from "react-router-dom";
import EnquiryNow from "../common/EnquiryNow";

const TeachingMethodology = () => {

  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <title>
        ISBM University's Innovative Teaching Methodologies
      </title>
      <meta name="ISBM University redefines education with cutting-edge pedagogy, blending interactive, tech-driven, and experiential learning for future-ready professionals." />

      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="ISBM University Pedagogical Approach: Shaping Future Leaders"
      />
      <meta
        property="og:description"
        content="Explore the dynamic teaching methodology and pedagogy at ISBM University. Our innovative approach focuses on empowering students for leadership roles in the world."
      />
      <meta property="og:url" content="https://isbmuniversity.edu.in/" />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="ISBM University Pedagogical Approach: Shaping Future Leaders"
      />
      <meta
        name="twitter:description"
        content="Explore the dynamic teaching methodology and pedagogy at ISBM University. Our innovative approach focuses on empowering students for leadership roles in the world."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <meta
        name="keywords"
        content="High-tech colleges in india, Top private universities in India, Technologically Advanced University"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Teaching Methodology at ISBM University</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Teaching Methodology
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Introduction Section */}
          <Row className="justify-content-center mb-5">
            <Col lg={12}>
              <div className="section-intro text-center">
                <p className="lead">
                  Since the start of the current millennium, new pedagogies have
                  begun to evolve to match the scale, scope, speed, and
                  intensity of new age digital economy. Advances in technology
                  are disrupting the status quo in higher education, compelling
                  us to push the boundaries of how we conceptualize the delivery
                  of education.
                </p>
              </div>
            </Col>
          </Row>

          {/* Technology Integration */}
          <Row>
            <Col lg={6} className="order-lg-1 order-2">
              <div className="methodology-content pe-lg-4">
                <h3 className="modern-title section-title-start text-blue">
                  Technology-Enhanced Learning
                </h3>
                <p>
                  Today's students expect their classes to include multiple
                  modes of engagement taking advantage of technology and the
                  learning spaces. Technology, in various forms, can be included
                  to enhance both in- and out-of-classroom learning experiences.
                  ISBM University recognizes this inherent need of today's time
                  and is making a pioneering effort to:
                </p>
                <ul className="styled-list">
                  <li>
                    Ensure increasing use of technology in teaching - learning
                    process
                  </li>
                  <li>Provide for individualized teaching</li>
                  <li>
                    Cater the need for lifelong education using technology
                  </li>
                  <li>
                    Ensure easy access to information leading to its explosion,
                    interactions round the globe
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={6} className="order-lg-2 order-1 mb-4 mb-lg-0">
              <div className="methodology-image rounded overflow-hidden shadow">
                <img
                  src={technologyImage}
                  alt="AI Hologram in Hand"
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        {" "}
        <div className="container-xxl">
          {" "}
          {/* Pedagogy Approaches */}
          <Row>
            <Col lg={12}>
              <div className="section-heading mb-5">
                <h2 className="text-blue modern-title section-title-start">
                  Our Pedagogical Approaches
                </h2>
                <p>
                  At ISBM University, learning activities are characterized by
                  active engagement, inquiry, problem solving and collaboration
                  with others.
                  The teacher acts as a guide, a facilitator and also co
                  explorer. They encourage learners to question, challenge and
                  formulate their ideas, opinions and conclusions. The
                  pedagogy to be used would be

                  :
                </p>
              </div>

              <div className="pedagogy-grid">
                <Row className="g-4">
                  {[
                    "Problem Based Learning",
                    "Learning Constructivist Approach",
                    "Case Studies",
                    "Peer Tutorials",
                    "E-Learning",
                    "Blended Learning",
                    "Flipped Classrooms",
                    "Experiential Learning",
                  ].map((approach, index) => (
                    <Col md={6} lg={3} key={index}>
                      <div className="approach-card bg-white p-4 rounded shadow-lg h-100">
                        <div className="approach-icon rounded-circle d-flex align-items-center justify-content-center mb-3">
                          <i
                            className={`ti ti-${getApproachIcon(
                              approach
                            )} text-blue fs-2`}
                          ></i>
                        </div>
                        <h4 className=" text-center text-blue ">{approach}</h4>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        {" "}
        <div className="container-xxl">
          {" "}
          {/* Comprehensive Methodology */}
          <Row>
            <Col lg={12}>
              <div className="comprehensive-methodology ">
                <h2 className="modern-title section-title-start text-blue">
                  Comprehensive Teaching Methodology
                </h2>
                <p>
                  We would use technology based learning platforms, social
                  media, internet and interactive Learning Management Systems to
                  deliver our programs.
                </p>
                <p>
                  The barriers are melting down across the world and it is our
                  scope and vision to connect the students from hinterlands of
                  Chhattisgarh to the Global platforms.
                </p>
                <p>
                  The teaching methodology and pedagogy at ISBM University are
                  designed to foster an engaging, student-centered learning
                  environment that prepares students for real- world challenges.
                  The university employs a variety of innovative and effective
                  teaching strategies, including:
                </p>

                <Accordion defaultActiveKey="0" className="mt-4">
                  {[
                    {
                      title: "Active Learning",
                      content:
                        "Encouraging students to actively participate in the learning process through discussions, problem-solving activities, and collaborative projects. This approach helps students develop critical thinking and communication skills.",
                    },
                    {
                      title: "Experiential Learning",
                      content:
                        "Integrating practical experiences such as internships, lab work, field trips, and community service into the curriculum. These hands-on opportunities allow students to apply theoretical knowledge to real-world situations.",
                    },
                    {
                      title: "Blended Learning",
                      content:
                        "Combining traditional classroom instruction with online learning resources and digital tools. This hybrid model offers flexibility and enhances the learning experience through multimedia content and interactive platforms.",
                    },
                    {
                      title: "Case-Based Learning",
                      content:
                        "Utilizing case studies to help students understand complex concepts and apply their knowledge to real-life scenarios. This method promotes analytical thinking and decision-making skills.",
                    },
                    {
                      title: "Research-Driven Education",
                      content:
                        " Encouraging students to engage in research projects and independent studies. This approach fosters a spirit of inquiry and innovation, preparing students for advanced academic pursuits and professional careers.",
                    },
                    {
                      title: "Interdisciplinary Teaching",
                      content:
                        "Promoting collaboration across different disciplines to provide a well-rounded education. This methodology helps students appreciate diverse perspectives and develop a holistic understanding of complex issues.",
                    },
                    {
                      title: "Mentorship and Advising",
                      content:
                        "Providing personalized support through faculty mentorship and academic advising. This guidance helps students navigate their academic journey, set career goals, and achieve their full potential.",
                    },
                    {
                      title: "Technology Integration",
                      content:
                        "Leveraging the latest educational technologies to enhance learning. This includes using learning management systems (LMS), virtual simulations, and digital resources to support and enrich the educational experience.",
                    },
                    {
                      title: "Assessment for Learning",
                      content:
                        "Implementing diverse assessment methods, such as formative assessments, peer reviews, and project-based evaluations, to provide continuous feedback and support student growth.",
                    },
                    {
                      title: "Global Learning",
                      content:
                        "Incorporating international perspectives and opportunities for global engagement. This includes study abroad programs, international collaborations, and exposure to global case studies, preparing students for a globalized world.",
                    },
                  ].map((item, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header>
                        <i
                          className={`ti ti-${getMethodIcon(
                            item.title
                          )} me-4 text-blue fs-3`}
                        ></i>
                        <h5 className="text-blue">{item.title}</h5>
                      </Accordion.Header>
                      <Accordion.Body>{item.content}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        <div className="container-xxl">
          {/* Placement & Incubation */}
          <Col lg={12}>
            <div className="section-intro mb-5">
              <p className="lead">
                Through these diverse and dynamic teaching methodologies, ISBM
                University aims to create a stimulating and supportive learning
                environment that equips students with the knowledge, skills, and
                attitudes necessary for success in their personal and
                professional lives.
              </p>
            </div>
          </Col>
          <Row>
            <Col md={6} className="mb-4 mb-md-0">
              <div className="highlight-card bg-white p-4 h-100 rounded-3 shadow border-top border-4 border-purple">
                <div className="d-flex align-items-start mb-3">
                  <div className="highlight-icon bg-blue rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0">
                    <i className="ti ti-briefcase text-light fs-3"></i>
                  </div>
                  <div>
                    <h3 className="h4 mb-2">Placement Assurance</h3>
                    <p className="mb-0">
                      We assure 100% placement assistance.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="highlight-card bg-white p-4 h-100 rounded-3 shadow border-top border-4 border-purple">
                <div className="d-flex align-items-start mb-3">
                  <div className="highlight-icon bg-blue rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0">
                    <i className="ti ti-plant text-light fs-3"></i>
                  </div>
                  <div>
                    <h3 className="h4 mb-2">Incubation Support</h3>
                    <p className="mb-0">
                      For those creative and innovative students who aspire to
                      start their own business venture, we provide them with
                      mentoring, money and models
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        {" "}
        <div className="container-xxl">
          {/* Learning Process */}
          <Row>
            <Col lg={12}>
              <div className="learning-process ">
                <h2 className="modern-title section-title-start text-blue">
                  Effective Teaching Learning Process
                </h2>
                <p>
                  Effective Teaching Learning Process lays strong foundation for
                  achieving academic success. ISBM University follows Learner
                  Centered Teaching Approach to promote and develop the
                  knowledge, skills, attitudes and continuous learning habit
                  among its students. Students do activities that enable them to
                  acquire knowledge, skills, and good thoughts and values. The
                  curriculum is innovative and comprehensive which enables our
                  students to get knowledge, skills and expertise which will
                  make them competitive in the global world.
                </p>

                <div className="process-components mt-4">
                  <Row className="g-4">
                    {[
                      {
                        title: "Practical Exposure",
                        content:
                          "Learning at ISBM University is an added advantage as it is not only limited to classrooms but practical exposure is made through field visits, summer internship, vocational courses and constant interaction with industry personnel / professional experts.",
                        icon: "ti ti-settings",
                      },
                      {
                        title: "Expert Lectures",
                        content:
                          "Guest Lectures/ Expert Lectures by eminent persons from Industry and Academia/Industrial/Field Visits. Use of Audio Visual Aids in Teaching Learning Process.",
                        icon: "ti ti-microphone",
                      },
                      {
                        title: "Emerging Techniques",
                        content:
                          "Seminars, Workshops on Emerging, Innovative techniques in various technical/non-technical fields by Industry Experts.",
                        icon: "ti ti-tools",
                      },
                      {
                        title: "Modern Classrooms",
                        content:
                          "ISBM University's classrooms and lecture halls are well equipped with modern teaching aids like multimedia projectors and computers with Wi-Fi connectivity. The simulated teaching software helps the students to understand the subject material in highly visualized form.",
                        icon: "ti ti-device-laptop",
                      },
                      {
                        title: "Industry Connect",
                        content:
                          "The guest lectures and seminars are delivered from the best industrial and corporate professionals to bring the application practices from the actual working environment.",
                        icon: "ti ti-building",
                      },
                      {
                        title: "Practical Sessions",
                        content:
                          "The practical sessions are the ideal testing grounds for students to apply. Test and confirm the LMS content.",
                        icon: "ti ti-flask",
                      },
                      {
                        title: "Case Studies",
                        content:
                          "Real-world case studies are integrated into the curriculum to provide practical insights.",
                        icon: "ti ti-files",
                      },
                      {
                        title: "Industrial Visits",
                        content:
                          "ISBM University also conducts student visits to reputed industries, acquainting students with the processes and practices that govern the modern industry.",
                        icon: "ti ti-map-pin",
                      },
                      {
                        title: "Mentoring System",
                        content:
                          "A student mentoring system has been evolved for giving personal attention to each of the students. The faculty member provides constant support and advice whenever he/she faces a problem with any aspect of the curricula.",
                        icon: "ti ti-user",
                      },
                    ].map((item, index) => (
                      <Col md={6} lg={4} key={index}>
                        <div className="process-card p-3 h-100 bg-white shadow rounded">
                          <div className="d-flex align-items-start">
                            <i
                              className={`${item.icon} text-blue fs-2 me-3 mt-1`}
                            ></i>
                            <div>
                              <h4 className="text-blue fw-bold mb-2">{item.title}</h4>
                              <p className="mb-0">{item.content}</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        {" "}
        <div className="container-xxl">
          {" "}
          {/* Evaluation System */}
          <Row>
            <Col lg={12}>
              <div className="evaluation-system ">
                <h2 className="modern-title section-title-start text-blue">
                  Academic Program and Evaluation System
                </h2>
                <p>
                  ISBM University provides a comprehensive range of academic
                  programs, including undergraduate, postgraduate, professional,
                  and research-focused courses across various disciplines. These
                  programs emphasize both theoretical foundations and practical
                  skills, catering to the diverse interests and career
                  aspirations of students.
                </p>
                <p>
                  The evaluation system at ISBM University is multi-faceted,
                  ensuring rigorous and fair assessment of student performance.
                  It includes continuous assessments such as quizzes,
                  assignments, and presentations, along with mid-term and final
                  examinations to gauge overall understanding. Practical
                  experiences are evaluated through project work and
                  internships, while research papers and theses are assessed for
                  originality and depth. Additionally, peer and self-assessment
                  methods encourage reflective learning, and className
                  participation is also considered. The university employs a
                  transparent grading system with clear criteria and structured
                  feedback mechanisms to support students' academic growth. This
                  integrated approach prepares students for success in their
                  future careers and academic endeavours.
                </p>
                <p>
                  The University emphasizes the importance of feedback in the
                  learning process. Structured feedback is provided after each
                  assessment, highlighting strengths and areas for improvement.
                  Students are encouraged to discuss their performance with
                  instructors and seek guidance for future academic endeavours.
                </p>
                <p>
                  In summary, ISBM University is committed to delivering a
                  high-quality education through a diverse range of academic
                  programs and a robust evaluation system. The university's
                  emphasis on continuous assessment, practical experiences, and
                  research initiatives ensures that students are well-prepared
                  for their future careers and academic pursuits. By fostering a
                  supportive and engaging learning environment, ISBM University
                  equips students with the knowledge, skills, and ethical
                  grounding necessary to succeed in an increasingly complex and
                  dynamic world.
                </p>

                <div className="gateway-box text-center mt-5 p-4 bg-white rounded shadow-lg">
                  <h3 className="fw-bold text-blue mb-3">
                    ISBM UNIVERSITY IS YOUR GATEWAY TO EXCELLENCE
                  </h3>
                  <Link
                    onClick={() => setModalShow(true)}
                    className="btn btn-outline-purple px-4 py-2"
                  >
                    Enquire Now{" "}
                    <i className="ti ti-arrow-right ms-2"></i>
                  </Link>
                  <EnquiryNow show={modalShow} onHide={() => setModalShow(false)} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

// Helper functions for icons
function getApproachIcon(approach) {
  const icons = {
    "Problem Based Learning": "help",
    "Learning Constructivist Approach": "stack",
    "Case Studies": "files",
    "Peer Tutorials": "users",
    "E-Learning": "device-laptop",
    "Blended Learning": "device-laptop",
    "Flipped Classrooms": "school",
    "Experiential Learning": "bulb",
  };
  return icons[approach] || "school";
}

function getMethodIcon(method) {
  const icons = {
    "Active Learning": "activity",
    "Experiential Learning": "flask",
    "Blended Learning": "device-laptop",
    "Case-Based Learning": "files",
    "Research-Driven Education": "microscope",
    "Interdisciplinary Teaching": "brain",
    "Mentorship and Advising": "user",
    "Technology Integration": "device-laptop",
    "Assessment for Learning": "checklist",
    "Global Learning": "world",
  };
  return icons[method] || "school";
}

export default TeachingMethodology;
